import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CssBaseline, Box, useTheme } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import ProtectedRoute from "./components/Layout/ProtectedRoute";
import Login from "./pages/Login";
import PatientList from "./pages/patients/PatientList";
import OPDList from "./pages/opd/OPDList";
import {
  mainContentBackground,
  mainContentText,
} from "./components/common/ColorTheme";
import EmployeeList from "./pages/employees/EmployeeList";
import ConsultingRoomList from "./pages/consultingrooms/ConsultingRoomList";

const App = () => {
  const muiTheme = useTheme();

  const ContentWrapper = ({ children }: { children: React.ReactNode }) => (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        backgroundColor: mainContentBackground,
        color: mainContentText,
        minHeight: "100vh",
        transition: muiTheme.transitions.create(["margin", "width"], {
          easing: muiTheme.transitions.easing.sharp,
          duration: muiTheme.transitions.duration.leavingScreen,
        }),
        overflowX: "hidden",
      }}
    >
      {children}
    </Box>
  );
  useEffect(() => {
    window.parent.postMessage({ type: "CONNECTED" }, "*");
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route element={<ProtectedRoute />}>
            <Route
              path="/"
              element={<Navigate to="/consulting-rooms" replace />}
            />

            <Route
              path="/patients"
              element={
                <ContentWrapper>
                  <PatientList />
                </ContentWrapper>
              }
            />

            <Route
              path="/opd"
              element={
                <ContentWrapper>
                  <OPDList />
                </ContentWrapper>
              }
            />

            <Route
              path="/employees"
              element={
                <ContentWrapper>
                  <EmployeeList />
                </ContentWrapper>
              }
            />
            <Route
              path="/consulting-rooms"
              element={
                <ContentWrapper>
                  <ConsultingRoomList />
                </ContentWrapper>
              }
            />
          </Route>

          {/* 404 */}
          <Route path="*" element={<div>404 Not Found</div>} />
        </Routes>

        <ToastContainer position="top-right" autoClose={3000} />
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
